import * as yup from "yup";
import {
  MAX_MESSAGE_LENGTH,
  MIN_TITLE_LENGTH,
} from "../../../../validation/lengthConstants";

export const validationSchema = yup.object().shape({
  memo: yup.string().min(MIN_TITLE_LENGTH).max(MAX_MESSAGE_LENGTH).trim(),
});
